module.exports = __webpack_public_path__ + "img/ic_email.92d38542.svg";